import { getContext } from '@fiverr-private/fiverr_context';
import { getIsUserInPriceRegulatedState } from '../getIsUserInPriceRegulatedState/getIsUserInPriceRegulatedState';

interface GetShouldDisplayFees {
    regionCode?: string;
}

export const getShouldDisplayFees = ({ regionCode = '' }: GetShouldDisplayFees): boolean => {
    const { countryCode } = getContext();
    return getIsUserInPriceRegulatedState(countryCode, regionCode);
};
